type Props = {
  label: string;
};
const Chip = ({ label }: Props) => {
  return <div>{label}</div>;
};

export default Chip;
